import { render, staticRenderFns } from "./returnBookdrop.vue?vue&type=template&id=a376cae0&scoped=true"
import script from "./returnBookdrop.vue?vue&type=script&lang=js"
export * from "./returnBookdrop.vue?vue&type=script&lang=js"
import style0 from "./returnBookdrop.vue?vue&type=style&index=0&id=a376cae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a376cae0",
  null
  
)

export default component.exports